import { makeAutoObservable, runInAction } from 'mobx'
import dayjs from 'dayjs'
import { Log } from '../models/Log'
import agent from '../api/agent'
import { store } from './store'

export default class LogsStore {
  logsRegistry = new Map<string, Log>()

  constructor() {
    makeAutoObservable(this)
  }

  get logs() {
    return Array.from(this.logsRegistry.values())
  }

  isPostNew = (id: string) => {
    const post = this.logsRegistry.get(id)
    const postDate = post?.date ? dayjs(post.date) : null
    return postDate && postDate.isAfter(dayjs().subtract(1, 'day'))
  }

  loadLogs = async () => {
    const { formatDateLocal } = store.methodsStore
    const { status, data: result } = await agent.Logs.allLogs()

    if (status === 200) {
      runInAction(() => {
        result.forEach((log) => {
          log.date = formatDateLocal(log.date)
          this.logsRegistry.set(log.typeId, log)
        })
      })
    }
  }
}
